<template>
  <form class="page">
    <div class="title login-title">{{ $t('login-title') }}</div>
    <text-component
      :label="$t('login')"
      :placeholder="$t('login')"
      v-model="form.login.value"
      :errors="$t(form.login.errors)"
      name="login"
      type="text"
      @input="validateIsRequired(form.login)"
    />
    <text-component
      :label="$t('password')"
      :placeholder="$t('password')"
      v-model="form.password.value"
      :errors="$t(form.password.errors)"
      name="password"
      type="password"
      @input="validateIsRequired(form.password)"
    />
    <button-component
      :class="{ 'btn--disabled': loading }"
      class="btn--login"
      role="input"
      type="submit"
      yellow
      @click.prevent="handleSubmit"
    >
      <template>
        <div v-if="!loading">
          {{ $t('login-button') }}
        </div>
        <div v-if="loading" class="loader">
          <loader white />
        </div>
      </template>
    </button-component>

    <error v-if="nonFieldErrors[0]" :errors="nonFieldErrors[0]" center />
  </form>
</template>

<script>
import TextComponent from '@/components/form/fields/Text'
import ButtonComponent from '@/components/Button'
import Loader from '@/components/Loader'
import Error from '@/components/Error'
import { validateIsRequired } from '@/utils/validator'
import service from '@/service'

export default {
  components: {
    TextComponent,
    ButtonComponent,
    Loader,
    Error
  },
  data() {
    return {
      validateIsRequired,
      loading: false,
      nonFieldErrors: [],
      form: {
        login: {
          value: '',
          errors: ''
        },
        password: {
          value: '',
          errors: ''
        }
      }
    }
  },
  methods: {
    validate() {
      return {
        validateLogin: validateIsRequired(this.form.login),
        validatePass: validateIsRequired(this.form.password)
      }
    },
    sendForm() {
      const data = {
        login: this.form.login.value,
        password: this.form.password.value
      }
      service.login
        .token(data)
        .then(resp => {
          localStorage.setItem('Token', JSON.stringify(resp.data.token))
          this.$router.push({ name: 'dashboard' })
        })
        .catch((err = {}) => {
          this.form.password.errors = 'error-login-or-pass'
          this.loading = false

          const errors = err.response && err.response.data
          this.nonFieldErrors = Array.isArray(errors) || []
        })
    },
    handleSubmit() {
      const validationPassed = !Object.values(this.validate()).includes(false)
      if (validationPassed) {
        this.sendForm()
        this.loading = true
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.login-title {
  text-align: center;
}

.btn--login {
  margin: 50px auto 15px;
  width: 55%;

  @include media-down(md) {
    width: 220px;
  }
}
</style>
